<template>
  <div ref="defaultLayout">
    <div id="userStatusList" :class="componentClassName">
      <a-page-heading>ユーザーステータス一覧 </a-page-heading>
      <m-section>
        <m-action-card>
          <m-data-table ref="dataTable" :empty-text="tableDataEmptyText" :fit="true" :data="tableData">
            <a-data-table-column prop="name" :min-width="100" label="名前" align="left" />
            <a-data-table-column prop="status" :min-width="100" :filterable="true" label="ステータス" align="left">
              <template #default="scope">
                <div class="t-user-status-list__status">
                  <div class="t-user-status-list__status__icon">
                    <div v-if="scope.row.statusIcon === icons.online" class="t-user-status-list__status__icon-online">
                      <a-icon :icon="scope.row.statusIcon" color="white" />
                    </div>
                    <div v-if="scope.row.statusIcon === icons.offline" class="t-user-status-list__status__icon-offline">
                      <a-icon :icon="scope.row.statusIcon" color="white" />
                    </div>
                    <div v-if="scope.row.statusIcon === icons.calling" class="t-user-status-list__status__icon-calling">
                      <!-- <a-icon :icon="scope.row.statusIcon" color="black" /> -->
                    </div>
                    <div v-if="scope.row.statusIcon === icons.logout" class="t-user-status-list__status__icon-logout">
                      <a-icon :icon="scope.row.statusIcon" color="white" />
                    </div>
                  </div>
                  <div class="t-user-status-list__status__text">
                    <span>{{ scope.row.status }}</span>
                  </div>
                </div>
              </template>
              <template #filter="scope">
                <m-filter-dialog
                  v-if="scope"
                  variant="filter"
                  :data-list="statusFilterDataList"
                  :selected-items="checkedStatus"
                  :handle-filter-cancel="() => handleFilterCancel('status')"
                  :handle-filter-confirm="data => handleFilterConfirm('status', data, 0)"
                />
              </template>
            </a-data-table-column>
            <a-data-table-column prop="elapsedTime" :min-width="100" label="ステータス経過時間" align="left" />
            <a-data-table-column type="action" :width="200" align="right">
              <template #default="scope">
                <a-button
                  :id="'make-call' + scope.index"
                  variant="round"
                  size="small"
                  label="発信"
                  color="primary"
                  icon="phone-outgoing-call"
                  icon-color="white"
                  :inline="true"
                  :disabled="scope.row.statusIcon === icons.calling || scope.row.statusIcon === icons.logout"
                  @click="showOutgoingUI(scope.row)"
                />
              </template>
            </a-data-table-column>
          </m-data-table>
        </m-action-card>
      </m-section>
    </div>
    <teleport to="body">
      <o-modal
        id="home_resultModal"
        v-model:visible="resultModalVisible"
        class="o-modal-remove-phone-number-confirmation"
        footer-variant="confirmation"
        width="442px"
        :footer-shadow="false"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
      >
        <template #title>{{ resultModalTitle }}</template>
        <a-text>
          <!-- eslint-disable -->
          <span v-html="resultModalContent" />
          <!-- eslint-enable -->
        </a-text>
        <template #footer>
          <a-button
            id="close-modal-button"
            variant="block"
            color="primary"
            label="OK"
            size="small"
            @click="handleCloseModal"
          />
        </template>
      </o-modal>
    </teleport>
    <o-outgoing-call-modal
      :modal-visible="outgoingModalVisible"
      :available-numbers="clientList"
      :selected-number="selectedClient"
      :title="selectedClientTitle"
      :handle-modal-close="handleOutgoingModalClose"
      :is-calling="currentIsCalling"
      :current-user-info="currentUserInfo"
      :current-phone-number="currentPhoneNumber"
      @update:current-number="handleNumberChange"
      @call="handleCall"
      @hangup="hangUpClick"
      @error:phone-number-suspended="showSuspendedNumber"
      @show-error-modal="showErrorModal"
    />
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import AButton from '@/components/atoms/button';
import AIcon from '@/components/atoms/icon';
import OOutgoingCallModal from '@/components/organisms/outgoing-call-modal';
import { showMsgBoxMixin } from '@/common/showMsgBox.js';
import { customValidate } from '@/common/customValidate.js';
import { customRequest } from '@/common/customRequest.js';
import { messageContent } from '@/common/messageContent.js';
import { USER_STATUSES, USER_STATUS_ICONS } from '@/libs/constants';

export default {
  name: 't-user-status-list',
  components: {
    AButton,
    AIcon,
    OOutgoingCallModal,
  },
  mixins: [showMsgBoxMixin, customValidate, customRequest],
  props: {
    class: {
      type: String,
      default: '',
    },
    clientList: {
      type: Array,
      default: new Array(0),
    },
    hangUpClick: {
      type: Function,
      default: () => {},
    },
    isCalling: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['call', 'update:currentNumber'],
  data: function () {
    return {
      tableData: [],
      tableDataEmptyText: '検索に一致する情報が見つかりませんでした',
      icons: {
        online: USER_STATUS_ICONS.ONLINE,
        offline: USER_STATUS_ICONS.OFFLINE,
        calling: USER_STATUS_ICONS.CALLING,
        logout: USER_STATUS_ICONS.LOGOUT,
      },
      statusFilterDataList: [
        { label: USER_STATUSES.ONLINE, value: USER_STATUSES.ONLINE },
        { label: USER_STATUSES.OFFLINE, value: USER_STATUSES.OFFLINE },
        { label: USER_STATUSES.CALLING, value: USER_STATUSES.CALLING },
        { label: USER_STATUSES.LOGOUT, value: USER_STATUSES.LOGOUT },
      ],
      selectedStatuses: [], // フィルタで選択したステータス
      selectedClient: '',
      selectedClientTitle: '',
      outgoingModalVisible: false,
      currentIsCalling: false,
      currentUserInfo: null,
      resultModalTitle: '',
      resultModalContent: '',
      resultModalVisible: false,
      interval: null,
      loginList: [],
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('t-user-status-list', this.error ? 'error' : '');
      return `${baseClassName} ${this.class}`.trim();
    },
  },
  watch: {
    isCalling(val) {
      if (!val) {
        //キャンセル
        this.handleOutgoingModalClose();
      } else {
        //発信中
        this.currentIsCalling = true;
      }
    },
  },
  created: function () {
    this.setTableData();
  },
  mounted: function () {
    if (this.$refs.defaultLayout.currentUserInfo) {
      this.currentUserInfo = this.$refs.defaultLayout.currentUserInfo;
    }
    this.interval = setInterval(this.setTableData, 1000);
  },
  unmounted: function () {
    clearInterval(this.interval);
  },
  methods: {
    setTableData() {
      this.tableData = [];
      this.getLoginList();
      let i = 0;
      for (const client of this.clientList) {
        const loginFlag = this.loginList[i];
        i++;
        const statusIcon =
          client.status === USER_STATUSES.CALLING
            ? USER_STATUS_ICONS.CALLING
            : client.status === USER_STATUSES.ONLINE
            ? USER_STATUS_ICONS.ONLINE
            : loginFlag
            ? USER_STATUS_ICONS.OFFLINE
            : USER_STATUS_ICONS.LOGOUT;
        const item = {
          name: client.label,
          clientName: client.value,
          status: client.status,
          statusIcon,
          elapsedTime: client.timestamp && loginFlag ? this.getFormatedTime(client.timestamp) : '',
        };
        if (!this.selectedStatuses.length || this.selectedStatuses.includes(item.status)) {
          this.tableData.push(item);
        }
      }
    },
    getFormatedTime(timestamp) {
      const now = new Date();
      const diffSeconds = now.getTime() - timestamp.seconds * 1000;
      return new Date(diffSeconds).toISOString().slice(11, 19);
    },
    getFilterColumnIndex(prop) {
      let columnIndex = -1;
      this.$refs.dataTable.columns.forEach((column, index) => {
        if (column.prop === prop) {
          columnIndex = index;
        }
      });
      return columnIndex;
    },
    getLoginList() {
      this.postRequest('/user_status/getLoginList', {
        clientList: this.clientList,
      }).then(e => {
        if (e.status === 'failed') {
          throw new Error('/user_status/getLoginList response was not ok.');
        }
        this.loginList = e.loginList;
      });
    },
    handleFilterCancel(prop) {
      const columnIndex = this.getFilterColumnIndex(prop);
      if (columnIndex !== -1) {
        this.$refs.dataTable.$refs.tableHeader.hideFilter(columnIndex);
      }
    },
    handleFilterConfirm(col, data) {
      this.selectedStatuses = data;
      this.setTableData(); // apply filter
      this.handleFilterCancel(col); // hide filter
    },
    showOutgoingUI(row) {
      console.log(row);
      this.outgoingModalVisible = true;
      this.selectedClient = row.clientName;
      this.selectedClientTitle = row.name;
      this.handleNumberChange(row.clientName);
    },
    handleNumberChange(e) {
      const client = this.clientList.find(client => client.value === e);
      this.$emit('update:currentNumber', client);
    },
    handleCall(from) {
      this.$emit('call', '', from);
      console.log('handleCall', from);
    },
    handleOutgoingModalClose() {
      this.outgoingModalVisible = false;
      this.currentIsCalling = false;
    },
    showSuspendedNumber() {
      this.handleOutgoingModalClose();
      this.showErrorModal(messageContent.notifyPendingPhoneNumber);
    },
    showErrorModal(message) {
      this.resultModalVisible = true;
      this.resultModalTitle = messageContent.errorModalTitle;
      this.resultModalContent = message;
    },
    handleCloseModal() {
      this.resultModalVisible = false;
      this.resultModalTitle = '';
      this.resultModalContent = '';
    },
  },
};
</script>
